import './live-content.css';

import { DsIcon } from '@descomplica/design-system-react';
import { observer, useViewModel } from '@descomplica/microfrontend-react';
import React from 'react';

import { ClassroomViewModel, Lesson } from '@/presentation/screens/classroom/classroom.vm';
import { ButtonContainer } from '@/presentation/shared-components/button';

type LiveContentParam = {
  lesson: Lesson;
  isScheduledLive?: boolean;
};

const PreviewScheduledLive = () => (
  <div className="preview-placeholder">
    <DsIcon image="clock" color="neutral-00" className="ds-clock-icon" />
  </div>
);

const PreviewReRunLive = () => (
  <div className="preview-placeholder">
    <div
      className="video-preview-placeholder"
      // style={{ backgroundImage: `url(${live.thumbUrl})` } as any}
      aria-hidden="true"
    />
  </div>
);

const formatDate = (date: string | Date) =>
  new Intl.DateTimeFormat('pt-br', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
    .format(new Date(date))
    .replace(',', ' às ');

const LiveContentContainer: React.FC<LiveContentParam> = ({
  lesson,
  isScheduledLive = true,
}: LiveContentParam) => {
  const vm = useViewModel(ClassroomViewModel);

  const onLiveVideoClick = () => {
    vm.setCurrentLesson(lesson);
    vm.toggleMobileSidebar();
  };

  return (
    <>
      <ButtonContainer
        className={isScheduledLive ? 'scheduled-live-content' : 'live-content'}
        onClick={onLiveVideoClick}
        ariaLabel={lesson.name}
      >
        {isScheduledLive ? <PreviewScheduledLive /> : <PreviewReRunLive />}
        <div className="preview-description">
          <p className="preview-description-title">{lesson.name}</p>
          <p className="preview-description-subtitle">
            {formatDate(lesson.streaming.startStreaming)}
          </p>
        </div>
      </ButtonContainer>
    </>
  );
};

export default observer(LiveContentContainer);
